import styled from "styled-components";
import { Link } from "react-router-dom";

export const Main = styled.main`
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing?.medium || "20px"};
  box-sizing: border-box;
`;

export const PageNotFound = styled.div`
  display: flex;
  align-self: center;
  align-items: center;
  text-align: center;
  height: 100%;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  &.active {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
